import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { getUsers, addBranch, updateBranchDetails } from "network/service";
import Autocomplete from "@mui/material/Autocomplete";
import { getPricingGroups } from "network/service";

export default function AddEditBranch(props) {
    const [newField, setNewField] = useState({ name: "", location: "", address: "" });
    const [errors, setErrors] = useState({});
    const { showNotification } = useNotification();
    const [users, setUsers] = useState([]);
    const [selUser, setSelUser] = useState(null);
    const [selPrice, setSelPrice] = useState(null);
    const [prices, setPrices] = useState(null);
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let isValid = true;
        let newErrors = {};

        if (newField.name.trim() === "") {
            newErrors = { ...newErrors, name: "Name is required" };
            isValid = false;
        }
        if (newField.location.trim() === "") {
            newErrors = { ...newErrors, location: "Location is required" };
            isValid = false;
        }
        if (newField.address.trim() === "") {
            newErrors = { ...newErrors, address: "Address is required" };
            isValid = false;
        }
        if (!selUser) {
            isValid = false;
            newErrors = { ...newErrors, user: "Select a valid Branch Manager" };
        }
        setErrors(newErrors);
        return isValid;
    }

    const submit = async () => {
        try {
            const isValid = validate();

            if (isValid) {
                setLoading(true);
                if (props.details && props.details._id) {
                    console.log("Updating Branch with id:", props.details._id);
                    await updateBranchDetails(props.details._id, { name: newField.name, location: newField.location, address: newField.address, manager: selUser._id, pricing_group: selPrice?._id ?? null });
                    showNotification("success", "Success", "Updated the Branch Details successfully");
                    props.handlesuccess();
                } else {
                    console.log("Adding new Branch");
                    await addBranch({ name: newField.name, location: newField.location, address: newField.address, manager: selUser._id, pricing_group: selPrice?._id ?? null });
                    showNotification("success", "Success", "Added the Branch Details successfully");
                    props.handlesuccess();
                }
                setLoading(false);
                props.handleclose();
            }
        } catch (err) {
            console.error("Error adding/updating branch:", err);
            setLoading(false);
            showNotification("error", "Error", "Failed to add/update Branch.");
        }
    };

    useEffect(() => {
        console.log("props.details:", props.details);
        if (props.details) {
            console.log("Setting newField with props.details:", props.details);
            setNewField({
                name: props.details.name,
                location: props.details.location,
                address: props.details.address
            });
        }
    }, [props.details]);

    useEffect(() => {
        getUsers().then((resp) => {
            setUsers(resp.data);
            if (props.details.manager) {
                for (let usr of resp.data) {
                    if (usr._id === props.details.manager._id) {
                        setSelUser(usr);
                    }
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, [setUsers, setSelUser]);

    useEffect(() => {
        getPricingGroups().then((resp) => {
            setPrices(resp.data);
            if (props.details.pricing_group) {
                for (let usr of resp.data) {
                    if (usr._id === props.details.pricing_group._id) {
                        setSelPrice(usr);
                    }
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, [setPrices, setSelPrice])


    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >
            <div>
                <DialogTitle>{props.details ? 'Edit Branch' : 'Add Branch'}</DialogTitle>
            </div>
            <DialogContent sx={{ minWidth: 500 }}>
                <Grid container direction="column" spacing={2}>
                    <Grid item >
                        <MDInput
                            label="Branch Name"
                            value={newField.name}
                            disabled={props.details}
                            fullWidth
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    name: e.target.value
                                });
                            }}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.name}</FormHelperText>}
                        // helperText={
                        //     <FormHelperText sx={{ color: '#FF0000', fontWeight: 800, margin: 0 }}>
                        //         {errors.name && "Customer Name is required"}
                        //     </FormHelperText>
                        // }
                        />

                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            disabled={props.details}
                            label="Branch Location"
                            value={newField.location}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.location}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    location: e.target.value.toUpperCase()
                                });
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <MDInput
                            label="Address"
                            disabled={props.details}
                            multiline
                            rows={3}
                            value={newField.address}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.address}</FormHelperText>}
                            fullWidth
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    address: e.target.value
                                });
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Autocomplete
                            label={"Manager"}
                            sx={{ flexGrow: 1 }}
                            error={errors.manager}
                            options={users}
                            getOptionLabel={(option) => option.username || ''}
                            renderInput={(params) => <MDInput {...params} label={"Manager"} fullWidth />}
                            onChange={(event, newValue) => {
                                setSelUser(newValue);
                            }}
                            value={selUser}
                        />
                        {(errors.user) && (
                            <FormHelperText sx={{ color: 'red', fontWeight: 800, marginLeft: 1 }}>
                                {errors.user}
                            </FormHelperText>
                        )}
                    </Grid>
                    <Grid item>
                        <Autocomplete
                            label={"Pricing Group"}
                            sx={{ flexGrow: 1 }}
                            options={prices}
                            getOptionLabel={(option) => option.name || ''}
                            renderInput={(params) => <MDInput {...params} label={"Pricing Group"} fullWidth />}
                            onChange={(event, newValue) => {
                                setSelPrice(newValue);
                            }}
                            value={selPrice}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="error" onClick={props.handleclose}>
                    <Icon>close</Icon>&nbsp;
                    Cancel
                </MDButton>
                <MDButton variant="gradient" color="success" onClick={submit}>
                    <Icon>save</Icon>&nbsp;
                    Save
                </MDButton>

            </DialogActions>
        </Dialog>
    )
}
